import Web3 from "web3";
import moment from "moment";
import {
  getCode,
  getBalance,
  getTransactionsCount,
  getLatestBlock,
  getAddress,
} from "../../../services/web3";
import { bscscanWaiter, accountTxlist } from "../../../services/bscscan";
import { getPrice } from "../../../services/binance";
import abi from "./abi.json";
import axios from "axios";
import { ethers } from "ethers";

export const getNormalTransactions = async (page: number, address: string) => {
  const latestBlock = await getLatestBlock().catch((_) => {
    return { number: NaN };
  });
  return await bscscanWaiter(accountTxlist, {
    address: address,
    startblock: 0,
    endblock: latestBlock.number,
    offset: 1000,
    sort: "desc",
    page,
  }).then((quote) => {
    const { result } = quote;
    if (!Array.isArray(result)) return [];

    const txs = result.map((tx) => {
      return {
        error: !!Number(tx.isError),
        hash: tx.hash,
        from: tx.from,
        to: tx.to,
        age: moment(Number(tx.timeStamp) * 1000).fromNow(true),
        value: tx.value,
      };
    });

    return txs;
  });
};

export const getAddressInfo = async (address: string) => {
  const bnbPrice = await getPrice("BNB", "USDT").then((quote) =>
    Number(quote.price)
  );
  const contract = await getCode(address);
  const balance = await getBalance(address).then((bal) =>
    Web3.utils.fromWei(bal, "ether")
  );
  const balanceUsd = (Number(balance) * bnbPrice).toLocaleString();
  const txCount = await getTransactionsCount(address);
  let tokenName: any;
  let tokenSymbol: any;
  let totalSupply: any;
  try {
    const provider = new ethers.providers.JsonRpcProvider(
      "http://b4hit-l1-node-backend.appworkdemo.com/archive"
    );

    const contractObject = new ethers.Contract(
      "0xe3cfBF398E18eE56C03b2dB13C734D27A32AbeF0",
      abi,
      provider
    );
    tokenName = await contractObject.name();
    tokenSymbol = await contractObject.symbol();
    const totals = await contractObject.totalSupply();
    totalSupply = totals.toString();
  } catch (error) {
    console.log("object", error);
    tokenName = " ";
    tokenSymbol = " ";
    totalSupply = " ";
  }

  return {
    bnbPrice,
    contract,
    balance,
    balanceUsd,
    txCount,
    tokenName,
    tokenSymbol,
    totalSupply,
  };
};

export const getAddressDetails = async (
  address: string,
  pageNo: Number,
  limit: Number
): Promise<{ data: any }> => {
  const data = await getAddress(address, pageNo, limit);
  return { data: data };
};
